var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 123,
    viewBox: "0 0 120 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8404 103.127H42.8669V111.491H76.8404V103.127Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.566 114.875H46.1018V122.423H73.566V114.875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8689 93.5716C47.2518 93.5716 47.5999 93.5278 47.9045 93.4226L72.1054 93.5015C72.4448 93.5804 72.8103 93.5892 73.1757 93.5015C74.7073 93.1333 75.3339 92.1777 75.4122 90.5471C75.5863 86.9177 75.9082 83.3058 78.3101 80.2725C79.6154 78.6244 80.8772 76.9412 82.0172 75.1791C85.6199 69.621 86.8295 63.4843 85.8462 56.9706C84.097 45.3548 73.1061 34.6331 59.7569 35.0276C56.0237 34.712 52.0729 35.8078 48.4614 37.605C41.9435 40.8312 37.3748 45.8457 35.208 53.087C32.5538 61.9764 33.7112 70.033 39.3763 77.3532C41.3691 79.9306 43.858 82.1661 44.1625 85.7166C44.3192 87.5489 44.5106 89.3724 44.6412 91.2046C44.7195 92.3004 45.0763 93.0894 45.9378 93.4051L54.0918 93.4313",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4529 22.0266V0.784912",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4988 31.6524L103.406 16.635",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3064 57.9614H119.383",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5273 31.6524L16.6204 16.635",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7268 57.9614H0.641357",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms);
export default __webpack_public_path__ + "static/media/LMS.f918cbaa.svg";
export { ForwardRef as ReactComponent };